// Curated list of countries relevant to marine/maritime work + African focus.
// States are provided for countries most likely to submit; others fall back to a text input.
export const COUNTRIES = [
  "Nigeria","Ghana","South Africa","Kenya","Egypt","Morocco","Algeria","Tunisia","Angola",
  "Cameroon","Côte d'Ivoire","Senegal","Tanzania","Mozambique","Namibia","Democratic Republic of Congo",
  "Republic of Congo","Gabon","Sierra Leone","Liberia","Ethiopia","Uganda","Rwanda","Sudan","Libya",
  "Botswana","Zambia","Zimbabwe","Mauritius","Madagascar","Seychelles","United Kingdom","United States",
  "France","Germany","Netherlands","Norway","Spain","Portugal","Italy","Greece","Turkey","UAE",
  "Saudi Arabia","Qatar","Oman","India","China","Singapore","Malaysia","Indonesia","Philippines","Brazil",
  "Argentina","Canada","Australia","New Zealand","Japan","South Korea","Other",
];

export const STATES = {
  "Nigeria": [
    "Abia","Adamawa","Akwa Ibom","Anambra","Bauchi","Bayelsa","Benue","Borno","Cross River","Delta",
    "Ebonyi","Edo","Ekiti","Enugu","FCT - Abuja","Gombe","Imo","Jigawa","Kaduna","Kano","Katsina",
    "Kebbi","Kogi","Kwara","Lagos","Nasarawa","Niger","Ogun","Ondo","Osun","Oyo","Plateau","Rivers",
    "Sokoto","Taraba","Yobe","Zamfara",
  ],
  "Ghana": ["Greater Accra","Ashanti","Western","Central","Eastern","Volta","Northern","Upper East","Upper West","Bono","Ahafo","Bono East","Oti","Savannah","North East","Western North"],
  "South Africa": ["Gauteng","Western Cape","Eastern Cape","KwaZulu-Natal","Free State","Limpopo","Mpumalanga","North West","Northern Cape"],
  "Kenya": ["Nairobi","Mombasa","Kisumu","Nakuru","Kiambu","Machakos","Uasin Gishu","Kilifi","Kwale","Lamu","Turkana","Bungoma","Meru","Nyeri","Kajiado","Other"],
  "Egypt": ["Cairo","Alexandria","Giza","Port Said","Suez","Ismailia","Damietta","Red Sea","South Sinai","North Sinai","Matrouh","Other"],
  "Morocco": ["Casablanca-Settat","Rabat-Salé-Kénitra","Marrakech-Safi","Tanger-Tétouan-Al Hoceima","Souss-Massa","Fès-Meknès","Oriental","Béni Mellal-Khénifra","Drâa-Tafilalet","Guelmim-Oued Noun","Laâyoune-Sakia El Hamra","Dakhla-Oued Ed-Dahab"],
  "United Kingdom": ["England","Scotland","Wales","Northern Ireland"],
  "United States": ["Alabama","Alaska","Arizona","California","Florida","Georgia","Hawaii","Louisiana","Maine","Maryland","Massachusetts","Michigan","New Jersey","New York","North Carolina","Oregon","Pennsylvania","South Carolina","Texas","Virginia","Washington","Other"],
  "UAE": ["Abu Dhabi","Dubai","Sharjah","Ajman","Umm Al Quwain","Ras Al Khaimah","Fujairah"],
  "India": ["Andhra Pradesh","Goa","Gujarat","Karnataka","Kerala","Maharashtra","Odisha","Tamil Nadu","West Bengal","Puducherry","Andaman & Nicobar","Lakshadweep","Other"],
};

export const PROFESSIONS = [
  "Marine Engineer",
  "Naval Architect",
  "Nautical Scientist",
  "Oceanographer",
  "Marine Geologist",
  "Port/Maritime Management Professional",
  "Marine Electrotechnologist",
  "Maritime Logistics Specialist",
  "Other",
];
